import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { env } from "../../../env";
import axiosInstance from "../../globalInspector/axiosInstance";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
const baseUrl = env.REACT_APP_BASE_URL;

export const scheduleTxnCreate = createAsyncThunk(
  "scheduleTxnCreate",
  async (values, { rejectWithValue }) => {
    const {
      amount,
      beneficiary_account_id,
      owner_account_id,
      category,
      additional_data,
      payment_method,
      frequency,
      confidential_transaction,
      occurrences,
      type_of_transactions,
      transaction_start_date,
      transaction_end_date,
      slot,
      transaction_day,
      transaction_month,
      scheduled_name,
    } = values?.paramsData;
    const requestBody = {
      amount,
      beneficiary_account_id,
      owner_account_id,
      category,
      additional_data: {
        data: additional_data,
      },
      payment_method,
      frequency,
      confidential_transaction,
      occurrences,
      type_of_transactions,
      transaction_start_date,
      transaction_end_date,
      slot,
      transaction_day,
      transaction_month,
      scheduled_name,
    };
    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
    };

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("BCScheduledTxn")
      ) {
        const response = await axiosInstance.post(
          `${baseUrl}/transactions/scheduled_beneficiary`,
          requestBody,
          config,
        );
        return response?.data;
      } else {
        values?.navigate("/feature_not_assigned");
      }
    } catch (error) {
      if (error?.response) {
        values?.navigate(
          "/beneficiary_transaction_dashboard/create_schedule/failed",
        );
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error);
      }
    }
  },
);

export const scheduleSuccessDetail = createAsyncThunk(
  "scheduleSuccessDetail",
  async (id, { rejectWithValue }) => {
    try {
      if (!id) {
        throw new Error("Invalid beneficiary id");
      }
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/scheduled_beneficiary/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const scheduleTxnOccurrences = createAsyncThunk(
  "scheduleTxnOccurrences",
  async (values, { rejectWithValue }) => {
    const { frequency, transaction_start_date, transaction_end_date } =
      values?.paramsData;

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("BOScheduledTxn")
      ) {
        const response = await axiosInstance.get(
          `${baseUrl}/transactions/scheduled_beneficiary/calculate_occurrences`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
            params: {
              frequency,
              transaction_start_date,
              transaction_end_date,
            },
          },
        );
        return response?.data;
      } else {
        values?.navigate("/feature_not_assigned", {
          state: { unavailableService: "BOScheduledTxn" },
        });
      }
    } catch (error) {
      if (error?.response) {
        const responseData = error?.response?.data;
        const errorMessage =
          responseData?.errors?.category?.[0] ||
          responseData?.errors?.additional_data?.[0] ||
          responseData?.errors?.base?.[0] ||
          responseData?.errors ||
          "An unexpected error occurred";

        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        return rejectWithValue(error?.response?.status);
      } else {
        CommonToast({
          text: "Network error. Please try again.",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        return rejectWithValue(error);
      }
    }
  },
);

export const scheduleTxnView = createAsyncThunk(
  "scheduleTxnView",
  async (values) => {
    const {
      page_no,
      page_item_count,
      amount,
      lifecycle_status,
      frequency,
      occurrences,
      slot,
      transaction_day,
      transaction_month,
      transaction_start_date,
      transaction_end_date,
      beneficiary_transaction_ids,
      payment_method,
      category,
      beneficiary_account_id,
      owner_account_id,
      confidential_transaction,
      start_date,
      end_date,
      category_value,
      category_name,
      search_string,
      distribution_lifecycle_status,
      scheduled_name,
    } = values;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/transactions/scheduled_beneficiary`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no: page_no,
            page_size: page_item_count,
            amount: amount,
            lifecycle_status: lifecycle_status,
            frequency: frequency,
            occurrences: occurrences,
            slot: slot,
            transaction_day: transaction_day,
            transaction_month: transaction_month,
            // transaction_start_date,
            transaction_start_date: transaction_start_date,
            transaction_end_date: transaction_end_date,
            beneficiary_transaction_ids: beneficiary_transaction_ids,
            payment_method: payment_method,
            category: category,
            scheduled_name: scheduled_name,
            beneficiary_account_id: beneficiary_account_id,
            owner_account_id: owner_account_id,
            confidential_transaction:
              confidential_transaction === "Show only confidential"
                ? "Y"
                : confidential_transaction === "Hide confidential"
                  ? "N"
                  : undefined,
            start_date,
            end_date,
            search_string: search_string,
            category_name: category_name,
            category_value: category_value,
            distribution_lifecycle_status: distribution_lifecycle_status,
          },
        },
      );
      return response?.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      throw error;
    }
  },
);

export const schedulesTxnDetail = createAsyncThunk(
  "schedulesTxnDetail",
  async (values, { rejectWithValue }) => {
    const id = values?.id;
    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("BVScheduledTxn")
      ) {
        const response = await axiosInstance.get(
          `${baseUrl}/transactions/scheduled_beneficiary/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
          },
        );
        return response.data;
      } else {
        values?.navigate("/feature_not_assigned");
      }
    } catch (error) {
      console.error("error", error);
      return rejectWithValue(error?.response?.data || error?.message);
    }
  },
);
export const schedulesTxnApproval = createAsyncThunk(
  "schedulesTxnApproval",
  async (values, { rejectWithValue }) => {
    const data = {
      txn_id: Array.isArray(values?.id) ? values?.id : [values?.id],
    };

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("BAScheduledTxn")
      ) {
        const response = await axiosInstance.put(
          `${baseUrl}/transactions/scheduled_beneficiary/approve`,
          data,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
          },
        );

        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const schedulesTxnReject = createAsyncThunk(
  "schedulesTxnReject",
  async (values, { rejectWithValue }) => {
    const id = Array.isArray(values?.id) ? values?.id : [values?.id];

    const data = {
      txn_id: id,
      reason: values?.reason,
    };

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("BAScheduledTxn")
      ) {
        const response = await axiosInstance.put(
          `${baseUrl}/transactions/scheduled_beneficiary/reject`,
          data, // <-- Correct body here
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
          },
        );

        return response.data;
      } else {
        values?.navigate("/feature_not_assigned");
      }
    } catch (error) {
      return rejectWithValue(error.response?.data ?? "An error occurred");
    }
  },
);

export const schedulesTxnDelete = createAsyncThunk(
  "schedulesTxnDelete",
  async (values, { rejectWithValue }) => {
    const data = {
      txn_id: [values?.id],
    };

    try {
      if (
        values?.services?.includes("Admin") ||
        values?.services?.includes("BAScheduledTxn")
      ) {
        const response = await axiosInstance.delete(
          `${baseUrl}/transactions/scheduled_beneficiary/delete`,
          {
            headers: {
              "Content-Type": "application/json",
              "X-Api-Key": sessionStorage.getItem("q2p_token"),
            },
            params: data,
          },
        );

        return response.data;
      } else {
        values?.navigate("/feature_not_assigned");
      }
    } catch (error) {
      console.error("Delete Error:", error);
      return rejectWithValue(error.message ?? "An error occurred");
    }
  },
);

export const MisReportCreate = createAsyncThunk(
  "MisReportCreate",
  async (values, { rejectWithValue }) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": sessionStorage.getItem("q2p_token"),
      },
      params: {
        page_no: values?.page_no,
        page_size: values?.page_size,
      },
    };

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/mis_report`,
        values?.payload,
        config,
      );
      if (values?.shouldNavigate) {
        const currentPath = values?.location?.pathname || "";
        const dashboardBasePath = currentPath.includes(
          "internal_transaction_dashboard",
        )
          ? "/internal_transaction_dashboard"
          : "/beneficiary_transaction_dashboard";

        values?.navigate(`${dashboardBasePath}/generate_mis_report/success`, {
          state: {
            payload: values?.payload,
          },
        });
      } else {
        toast.dismiss();
        CommonToast({
          text: "MIS Report generated successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      return response?.data;
    } catch (error) {
      CommonToast({
        text: error?.response?.data?.error,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      CommonToast({
        text: error?.response?.data?.error?.base?.[0],
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      error?.response?.data?.errors?.base?.[0]?.map((err) => {
        return CommonToast({
          text: String(err),
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      });
      if (error?.response) {
        return rejectWithValue(error?.response?.data);
      } else {
        return rejectWithValue(error);
      }
    }
  },
);

export const MisReportCreateDownload = createAsyncThunk(
  "MisReportCreateDownload",
  async (values, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        `${baseUrl}/mis_report.csv`,
        JSON.stringify(values?.payload),
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          responseType: "blob",
        },
      );
      let blob = response.data;

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      link.setAttribute("download", `MIS_Report.csv`);

      document.body.appendChild(link);

      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      return true;
    } catch (error) {
      let errorMessage = "Something went wrong";

      try {
        const errorBlob = await error.response.data;
        const text = await errorBlob.text();
        const parsed = JSON.parse(text);

        errorMessage =
          parsed?.errors?.base[0] ||
          parsed?.errors?.token_expired ||
          parsed?.errors?.message ||
          parsed?.message ||
          parsed?.error ||
          error.message ||
          "Something went wrong";
      } catch (err) {
        errorMessage = error.message || "Something went wrong";
      }
      toast.dismiss();
      CommonToast({
        text: errorMessage,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return rejectWithValue(errorMessage);
    }
  },
);

const schedulesTxnSlice = createSlice({
  name: "schedulesTxnSlice",
  initialState: {
    schedulesTxnCreateData: null,
    schedulesTxnCreateLoading: null,
    schedulesTxnCreateError: null,

    scheduleSuccessData: null,
    scheduleSuccessLoading: null,
    scheduleSuccessError: null,

    schedulesTxnOccurrencesData: null,
    schedulesTxnOccurrencesLoading: null,
    schedulesTxnOccurrencesError: null,

    schedulesTxnViewAllData: null,
    schedulesTxnViewAllLoading: null,
    schedulesTxnViewAllError: null,

    schedulesTxnDetailData: null,
    schedulesTxnDetailLoading: null,
    schedulesTxnDetailError: null,

    schedulesTxnApprovalData: null,
    schedulesTxnApprovalLoading: null,
    schedulesTxnApprovalError: null,

    schedulesTxnRejectData: null,
    schedulesTxnRejectLoading: null,
    schedulesTxnRejectError: null,

    schedulesTxnDeleteData: null,
    schedulesTxnDeleteLoading: null,
    schedulesTxnDeleteError: null,

    storedPage: 1,

    MisReportCreateData: null,
    MisReportLoading: true,
    MisReportError: null,
  },

  reducers: {
    resetpage: (state) => {
      state.storedPage = 1;
    },
    setStoredPage: (state, action) => {
      state.storedPage = action.payload;
    },
    resetScheduleTxnDetailSlice: (state) => {
      state.schedulesTxnDetailData = null;
      state.schedulesTxnDetailLoading = null;
      state.schedulesTxnDetailError = null;
    },
    resetScheduleTxnDiscardSlice: (state) => {
      state.schedulesTxnDeleteData = null;
      state.schedulesTxnDeleteLoading = false;
      state.schedulesTxnDeleteError = null;
    },
    clearSchedulesTxnErrors: (state) => {
      state.schedulesTxnApprovalError = null;
      state.schedulesTxnRejectError = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(MisReportCreate.pending, (state) => {
      state.MisReportLoading = true;
    });
    builder.addCase(MisReportCreate.fulfilled, (state, action) => {
      state.MisReportLoading = false;
      state.MisReportCreateData = action?.payload;
    });
    builder.addCase(MisReportCreate.rejected, (state, action) => {
      state.MisReportLoading = false;
      state.MisReportCreateData = false;
      state.MisReportError = action?.payload;
    });

    builder.addCase(scheduleTxnCreate.pending, (state) => {
      state.schedulesTxnCreateLoading = true;
    });
    builder.addCase(scheduleTxnCreate.fulfilled, (state, action) => {
      state.schedulesTxnCreateLoading = false;
      state.schedulesTxnCreateData = action?.payload;
    });
    builder.addCase(scheduleTxnCreate.rejected, (state, action) => {
      state.schedulesTxnCreateLoading = false;
      state.schedulesTxnCreateData = false;
      state.schedulesTxnCreateError = action?.payload;
    });
    builder.addCase(scheduleSuccessDetail.pending, (state, action) => {
      state.scheduleSuccessLoading = true;
    });
    builder.addCase(scheduleSuccessDetail.fulfilled, (state, action) => {
      state.scheduleSuccessLoading = false;
      state.scheduleSuccessError = null;
      state.scheduleSuccessData = action.payload;
    });
    builder.addCase(scheduleSuccessDetail.rejected, (state, action) => {
      state.scheduleSuccessError = action.payload;
      state.scheduleSuccessLoading = false;
      state.scheduleSuccessData = null;
    });
    builder.addCase(scheduleTxnOccurrences.pending, (state) => {
      state.schedulesTxnOccurrencesLoading = true;
    });
    builder.addCase(scheduleTxnOccurrences.fulfilled, (state, action) => {
      state.schedulesTxnOccurrencesLoading = false;
      state.schedulesTxnOccurrencesData = action?.payload;
    });
    builder.addCase(scheduleTxnOccurrences.rejected, (state, action) => {
      state.schedulesTxnOccurrencesLoading = false;
      state.schedulesTxnOccurrencesData = false;
      state.schedulesTxnOccurrencesError = action?.payload;
    });
    builder.addCase(scheduleTxnView.pending, (state) => {
      state.schedulesTxnViewAllLoading = true;
    });
    builder.addCase(scheduleTxnView.fulfilled, (state, action) => {
      state.schedulesTxnViewAllLoading = false;
      state.schedulesTxnViewAllData = action?.payload;
    });
    builder.addCase(scheduleTxnView.rejected, (state, action) => {
      state.schedulesTxnViewAllLoading = false;
      state.schedulesTxnViewAllData = false;
      state.schedulesTxnViewAllError = action?.payload;
    });

    builder.addCase(schedulesTxnDetail.pending, (state) => {
      state.schedulesTxnDetailLoading = true;
    });
    builder.addCase(schedulesTxnDetail.fulfilled, (state, action) => {
      state.schedulesTxnDetailLoading = false;
      state.schedulesTxnDetailData = action?.payload;
    });
    builder.addCase(schedulesTxnDetail.rejected, (state, action) => {
      state.schedulesTxnDetailData = false;
      state.schedulesTxnDetailLoading = false;
      state.schedulesTxnDetailError = action?.payload;
    });

    builder.addCase(schedulesTxnApproval.pending, (state) => {
      state.schedulesTxnApprovalLoading = true;
    });
    builder.addCase(schedulesTxnApproval.fulfilled, (state, action) => {
      state.schedulesTxnApprovalLoading = false;
      state.schedulesTxnApprovalData = action?.payload;
    });
    builder.addCase(schedulesTxnApproval.rejected, (state, action) => {
      sessionStorage.setItem(
        "ScheduleDataError",
        JSON.stringify(action.payload?.errors?.base),
      );
      state.schedulesTxnApprovalData = false;
      state.schedulesTxnApprovalLoading = false;
      state.schedulesTxnApprovalError = action?.payload;
    });
    builder.addCase(schedulesTxnReject.pending, (state) => {
      state.schedulesTxnRejectLoading = true;
    });
    builder.addCase(schedulesTxnReject.fulfilled, (state, action) => {
      state.schedulesTxnRejectLoading = false;
      state.schedulesTxnRejectData = action?.payload;
    });
    builder.addCase(schedulesTxnReject.rejected, (state, action) => {
      sessionStorage.setItem(
        "ScheduleDataError",
        JSON.stringify(action.payload?.errors?.base),
      );
      state.schedulesTxnRejectLoading = false;
      state.schedulesTxnRejectError = action?.payload;
      state.schedulesTxnRejectData = false;
    });
    builder.addCase(schedulesTxnDelete.pending, (state) => {
      state.schedulesTxnDeleteLoading = true;
    });
    builder.addCase(schedulesTxnDelete.fulfilled, (state, action) => {
      state.schedulesTxnDeleteLoading = false;
      state.schedulesTxnDeleteData = action?.payload;
    });
    builder.addCase(schedulesTxnDelete.rejected, (state, action) => {
      state.schedulesTxnDeleteLoading = false;
      state.schedulesTxnDeleteError = action?.payload;
      state.schedulesTxnDeleteData = false;
    });
  },
});

export const {
  resetpage,
  setStoredPage,
  resetScheduleTxnDetailSlice,
  resetScheduleTxnDiscardSlice,
  clearSchedulesTxnErrors,
} = schedulesTxnSlice.actions;
export default schedulesTxnSlice.reducer;
